export default function calculatePeopleSupplement(
  adultCount,
  childrenCount,
  roomId,
  nights
) {
  const totalPeopleCount = adultCount + childrenCount;
  const childRate = 40; // Tariffa per bambino per notte
  const adultRate = 50; // Tariffa per adulto extra per notte
  let peopleSupplement = 0;

  // Calcolo del numero di persone extra (oltre le prime due)
  const extraPeopleCount = totalPeopleCount > 2 ? totalPeopleCount - 2 : 0;

  // Se ci sono persone extra, dobbiamo determinare quanti sono bambini e quanti adulti
  const extraChildrenCount = Math.min(extraPeopleCount, childrenCount);
  const extraAdultCount = extraPeopleCount - extraChildrenCount;

  // Calcolo del supplemento per bambini e adulti extra
  const childrenSupplement = extraChildrenCount * childRate * nights;
  const adultsSupplement = extraAdultCount * adultRate * nights;
  // Calcolo del supplemento totale
  peopleSupplement = childrenSupplement + adultsSupplement;

  // Restituiamo i valori separati
  return {
    totalSupplement: peopleSupplement, // Supplemento totale
    childrenSupplement: childrenSupplement, // Supplemento bambini extra
    adultsSupplement: adultsSupplement, // Supplemento adulti extra
    extraChildrenCount: extraChildrenCount, // Numero di bambini extra
    extraAdultCount: extraAdultCount, // Numero di adulti extra
  };
}
